/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page4_Correct_SerialInputs */



/**
* | output |
* | --- |
* | "SERIAL number must match the maintenance plan" |
*
* @param {Intervention_Plan_Pdf_Page4_Correct_SerialInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page4_correct_serial = /** @type {((inputs?: Intervention_Plan_Pdf_Page4_Correct_SerialInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page4_Correct_SerialInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("SERIAL number must match the maintenance plan")
	return /** @type {LocalizedString} */ ("Le n° SERIAL doit correspondre à celui indique sur le plan de maintenance")
});